import {axiosInstanceCMS} from "../services/AxiosInstance"
const API_URL = "/blogs"
const BLOGS_PAGE_CAP = 100
const BLOGS_DEFAULT_LIMIT = 10

export const getBlogs = async (limit = 10) => {
  try {
    const safeLimit = Math.max(1, Math.min(BLOGS_PAGE_CAP, Number.parseInt(limit, 10) || BLOGS_DEFAULT_LIMIT))
    const response = await axiosInstanceCMS.get(`${API_URL}?limit=${safeLimit}`)
    return response.data
  } catch (error) {
    console.error("Error fetching blogs", error)
    throw error
  }
}

export const getBlog = async (blogId) => {
  try {
    const response = await axiosInstanceCMS.get(`${API_URL}/${blogId}`)
    return response.data
  } catch (error) {
    console.error("Error fetching blog", error)
    throw error
  }
}

export const addBlog = async (blogData) => {
  try {
    const response = await axiosInstanceCMS.post(API_URL, { ...blogData, isDeleted: false })
    return response.data
  } catch (error) {
    console.error("Error adding blog", error)
    throw error
  }
}

export const updateBlog = async (blog, blogId) => {
  try {
    const response = await axiosInstanceCMS.put(`${API_URL}/${blogId}`, blog)
    return response.data
  } catch (error) {
    console.error("Error updating blog", error)
    throw error
  }
}

export const deleteBlogs = async (blogId) => {
  try {
    const response = await axiosInstanceCMS.delete(`${API_URL}/${blogId}`)
    return response.data
  } catch (error) {
    console.error("Error deleting blog", error)
    throw error
  }
}
